export default "__VITE_ASSET__DI5KODkj__"